/* src/app/webhook-creator/webhook-creator/webhook-threadlist-component/webhook-threadlist.component.scss */
:host {
  display: flex;
  height: 100%;
  overflow: auto;
  flex-direction: column;
}
.list-thread-info {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 0;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-threads {
  display: flex;
  height: 100%;
  overflow: auto;
  flex-direction: column;
}
.table-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  position: relative;
}
.expanded-content {
  white-space: pre-line;
}
/*# sourceMappingURL=webhook-threadlist.component.css.map */
